// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1gN79","cell":"ColumnAccessor_cell__2job6","firstCellAccent":"ColumnAccessor_firstCellAccent__213j3"};